import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import Layout from 'presentation/components/layout'
import { GoalAssignmentRoutes } from 'presentation/routes/privatePages/routes/goalAssignment'
import { AvailableDestinationsRoutes } from 'presentation/routes/privatePages/routes/availableDestinations'
import { SelectedDestinationsRoutes } from 'presentation/routes/privatePages/routes/selectedDestinations'
import { AvailableDestinationsByPackageRoutes } from 'presentation/routes/privatePages/routes/availableDestinationsByPackage'
import { RepLoadRoutes } from './routes/repLoadRoutes'

const NotFound = lazy(() => import('presentation/pages/notFound404'))

export const privateRoutes = [
  ...RepLoadRoutes,
  ...GoalAssignmentRoutes,
  ...AvailableDestinationsRoutes,
  ...AvailableDestinationsByPackageRoutes,
  ...SelectedDestinationsRoutes,
]

type PrivatePagesProps = {
  rol: string
}

export default function PrivatePages({ rol }: PrivatePagesProps) {
  return (
    <Layout>
      <Routes>
        <Route path="*" element={<NotFound />} />
        {privateRoutes.map((routes: any) => {
          if (routes.rols.find((rols: any) => rols === rol || rols === '*')) {
            return <Route key={routes.path} path={routes.path} element={<routes.element />} />
          }
          return null
        })}
      </Routes>
    </Layout>
  )
}
